import moment from 'moment';
import ExportJsonExcel from 'js-export-excel';

class AccountsReportExcel {
    exportExcel(data) {
        let option = {};  // La opción representa el archivo de Excel
        let accountingAccountsData = this.dataReportPatiensExport(data);
        option.fileName = 'Cuentas Contables';  // Nombre del archivo Excel
        option.datas = [
            {
                sheetData: accountingAccountsData.data,  // Fuente de datos en archivo Excel
                sheetName: 'Cuentas Contables',  // nombre de la página de hoja en el archivo de Excel
            }
        ]
        let toExcel = new ExportJsonExcel(option);  // Generar archivo de Excel
        toExcel.saveExcel();  // Descargar archivo de Excel
    }

    dataReportPatiensExport(dataAcct) {
        let dataTable = [];
        let CasillasTitulos = this.generarTitulos();
        dataTable.push(CasillasTitulos);
        for (let i = 0; i < dataAcct.length; i++) {
            let infoDetallada = this.generarInformacionDetallada(dataAcct[i]);
            dataTable.push(infoDetallada);
        }

        let sheet =
        {
            data: dataTable
        }

        return sheet;
    }

    generarTitulos() {
        let casillas = {
            '1': "rut",
            '2': "prei",
            '3': "factura_ind",
            '4': "fecha_factura",
            '5': "acct",
            '6': "credito",
            '7': "cuotas",
            '8': "vendedor",
            '9': "proyecto",
            '10': "actividad",
            '11': "dpto",
            '12': "centro_costo",
            '13': "contable_db",
            '14': "contable_cr",
            '15': "Descripción"
        }
        return casillas;
    }

    generarInformacionDetallada(data) {
        let casillas = {
            '1': data.rut != null && data.rut != undefined ? data.rut : "",
            '2': data.prefijo != null && data.prefijo != undefined ? data.prefijo : "",
            '3': data.factura_ind != null && data.factura_ind != undefined ? data.factura_ind : "",
            '4': data.fecha_factura != null && data.fecha_factura != undefined ? data.fecha_factura : "",
            '5': data.acct != null && data.acct != undefined ? data.acct : "",
            '6': data.credito != null && data.credito != undefined ? data.credito : "",
            '7': data.cuotas != null && data.cuotas != undefined ? data.cuotas : "",
            '8': data.vendedor != null && data.vendedor != undefined ? data.vendedor : "",
            '9': data.proyecto != null && data.proyecto != undefined ? data.proyecto : "",
            '10': data.actividad != null && data.actividad != undefined ? data.actividad : "",
            '11': data.dpto != null && data.dpto != undefined ? data.dpto : "",
            '12': data.centro_costo != null && data.centro_costo != undefined ? data.centro_costo : "",
            '13': data.contable_db != null && data.contable_db != undefined ? data.contable_db : "",
            '14': data.contable_cr != null && data.contable_cr != undefined ? data.contable_cr : "",
            '15': data.descripcion != null && data.descripcion != undefined ? data.descripcion : "",
        }
        return casillas;
    }

}

export default new AccountsReportExcel();